import { IconProps } from './types';

export const RepairsIcon = ({ title = 'Repairs Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="39" fill="none" viewBox="0 0 38 39" {...props}>
        <title>{title}</title>
        <path
            fill="#FB0"
            d="M5.23 1.491.94 5.85a3.3 3.3 0 0 0 0 4.614l7.224 7.34a3.19 3.19 0 0 0 2.27.956h3.487l4.013-4.078v-3.543a3.3 3.3 0 0 0-.94-2.307L9.77 1.492a3.175 3.175 0 0 0-4.54 0"
        ></path>
        <path
            fill="#fff"
            d="M8.067 4.317a.794.794 0 0 0-1.135 0 .825.825 0 0 0 0 1.154l6.421 6.525a.794.794 0 0 0 1.135 0 .825.825 0 0 0 0-1.154zM4.856 7.58a.794.794 0 0 0-1.135 0 .825.825 0 0 0 0 1.153l6.421 6.526a.794.794 0 0 0 1.136 0 .825.825 0 0 0 0-1.154z"
        ></path>
        <path
            fill="#D9DBDD"
            d="m19.54 23.654 9.63 9.788v2.187c0 .653.384 1.242.974 1.5l4.146 1.805a.79.79 0 0 0 .884-.173l2.442-2.482a.83.83 0 0 0 .17-.898l-1.777-4.213a1.61 1.61 0 0 0-1.475-.989h-2.152l-9.632-9.788z"
        ></path>
        <path
            fill="#0A2F73"
            d="M27.566 7.34v2.448c0 .45.359.816.802.816h2.408l5.888-5.319c.518-.468 1.336-.094 1.336.61v4.284c0 .799-.289 1.57-.811 2.167l-3.934 4.498a5.58 5.58 0 0 1-4.2 1.916H25.96L7.362 37.66a3.175 3.175 0 0 1-4.54 0L.94 35.75a3.3 3.3 0 0 1 0-4.614l18.599-18.9V9.269c0-1.734.776-3.374 2.109-4.458L26.686.715A3.18 3.18 0 0 1 28.692 0h4.16c.715 0 1.073.879.567 1.392z"
        ></path>
        <path
            fill="#fff"
            d="M7.5 32.626c0 .901-.72 1.632-1.606 1.632s-1.605-.73-1.605-1.632c0-.9.718-1.631 1.605-1.631s1.605.73 1.605 1.631"
        ></path>
    </svg>
);
